import React from "react";
import PropTypes from "prop-types";

import { t } from "../../../services";
import { RadialTooltipContainer, RadialTooltipTotal, RadialTooltipValues } from "../styled";

export const RadialChartTooltip = ({ data, total }) => {
  const totalTitle = `(${total})`;

  return (
    <RadialTooltipContainer>
      <RadialTooltipValues>
        <span>{t(data?.label)}</span>
        <p>{data?.value}%</p>
      </RadialTooltipValues>
      <RadialTooltipTotal>
        <div></div>
        <p>{totalTitle}</p>
      </RadialTooltipTotal>
    </RadialTooltipContainer>
  );
};

RadialChartTooltip.propTypes = {
  data: PropTypes.shape({
    value: PropTypes.number.isRequired,
    fill: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    isActive: PropTypes.bool.isRequired
  }),
  total: PropTypes.number
};
